import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { csCZ, enUS } from '@mui/material/locale';
import { enUS as dgEnUs } from '@mui/x-data-grid/locales';
import { muiGridCsCZ } from '@/locales/cs/muiGridCsCZ.ts';

const localeMap = {
  en: [enUS, dgEnUs],
  cs: [csCZ, muiGridCsCZ],
};

// Create a custom theme
export const getTheme = (locale: string) => {
  const translations =
    locale in localeMap ? localeMap[locale as keyof typeof localeMap] : localeMap.en;

  return responsiveFontSizes(
    createTheme(
      {
        palette: {
          primary: {
            main: '#000032',
          },
          secondary: {
            main: '#00e1e1',
          },
          background: {
            default: grey[50],
          },
        },
        typography: {
          h1: {
            fontSize: '1.7rem',
          },
          h2: {
            fontSize: '1.4rem',
          },
          h3: {
            fontSize: '1.2rem',
            letterSpacing: '0.1rem',
          },
          h4: {
            fontSize: '1rem',
            fontWeight: 'bold',
          },
          h5: {
            fontSize: '1rem',
            letterSpacing: '0.1rem',
          },
        },
        shape: {
          borderRadius: 8,
        },
        zIndex: {
          appBar: 1300,
        },
      },
      ...translations
    )
  );
};
